import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import type { ReleaseNote } from '@/lib/release-notes'

/** Bản thông báo cập nhật đang bật mới nhất do Platform quản lý (null = chưa có → dùng bản dự phòng trong mã nguồn). */
export function useLatestReleaseNote(enabled: boolean) {
  return useQuery<{ note: (ReleaseNote & { slug: string; releasedAt: string }) | null }>({
    queryKey: ['release-notes', 'latest'],
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: async () => (await api.get('/release-notes/latest')).data,
  })
}
